import { usePermissions } from "@podtrac/common/accounts";
import React from "react";
import { Helmet } from "react-helmet";
import { FaCheckCircle, FaMinusCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useAccountID } from "../../store/account";
import { useShows } from "../../store/shows";

export default function Shows() {
    const accountID = useAccountID();
    const { data: permissions } = usePermissions(accountID);
    const navigate = useNavigate();
    const { data: shows } = useShows(accountID);
    return (
        <>
            <Helmet>
                <title>Shows - Podtrac</title>
            </Helmet>
            <h1>Shows</h1>
            {permissions?.canAddShow ? (
                <button onClick={() => navigate("../../add-show")}>Add a show</button>
            ) : null}
            <table style={{ marginTop: "1rem" }} className="table">
                <thead>
                    <tr>
                        <th style={{ textAlign: "left" }}>Title</th>
                        {/*<th style={{ textAlign: "center" }}>Status</th>*/}
                        <th style={{ textAlign: "center" }}>Active</th>
                    </tr>
                </thead>
                <tbody>
                    {shows &&
                        shows.items?.map(s => (
                            <tr key={s.showID}>
                                <td style={{ textAlign: "left" }}>{s.showName}</td>
                                {/*<td style={{ textAlign: "center" }}>[ TODO: feed status ]</td>*/}
                                <td style={{ textAlign: "center" }}>
                                    {s.active ? (
                                        <FaCheckCircle style={{ fill: "#0c0" }} />
                                    ) : (
                                        <FaMinusCircle style={{ fill: "#c00" }} />
                                    )}
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
            {/*<pre>{JSON.stringify(shows, null, 2)}</pre>*/}
        </>
    );
}
